









































export default

	props: block: Object

	data: ->
		loaded: false

	mounted: ->
		{ @gsap, @ScrollTrigger } = await import('gsap/all')
		@gsap.registerPlugin(@ScrollTrigger)

		# if image, then call setup
		@motionSetup()

	destroyed: -> @motionCleanup

	methods:
		motionSetup: ->
			trigger = @$refs.trigger
			mask = @$refs.mask
			asset = @$refs.asset
			box = @$refs.box

			@loaded = true

			@gsap.set mask, {
				'clip-path': 'polygon(25% 55%, 75% 55%, 75% 100%, 25% 100%)'
			}

			@tl = @gsap.timeline()
			@tl2 = @gsap.timeline()
			@tl.to box, 0.5, {
				marginTop: 0
			}, 0
			@tl.to mask, 0.5, {
				'clip-path': 'polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%)'
			}, 0

			@tl2.to asset, 1, {
				width: '100%'
				height: '100%'
			}, 0

			@trigger1 = @ScrollTrigger.create(
				animation: @tl
				trigger: trigger
				start: 'top top'
				end: '+=1100'
				scrub: 1
				pin: true
				toggleActions: "restart pause reverse pause"
			)

			@trigger2 = @ScrollTrigger.create(
				animation: @tl2
				trigger: trigger
				start: 'top top'
				end: '+=900'
				scrub: 2
				toggleActions: "restart pause reverse pause"
			)

		motionCleanup: ->
			@trigger1?.kill?()

